import { useEffect } from 'react';
export function useStrictModeSafeCleanupEffect(cleanup) {
    var timeout;
    useEffect(function () {
        clearTimeout(timeout);
        return function () {
            timeout = setTimeout(cleanup);
        };
    }, []);
}
//# sourceMappingURL=useStrictModeSafeCleanupEffect.js.map